var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{staticClass:"table-wrapper"},[_c('tr',[_c('td',[_vm._v("\n            "+_vm._s(this.data)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }